import { useUserName } from '../../contexts/userName';
import './styles.scss';

function WelcomeUser({ schoolsList }) {
  const { userName } = useUserName();

  function shortenedUserName() {
    return userName.split(' ')[0];
  }

  return (
    <div className='welcome'>
      {/* <img className="welcome__user-img" src={userImg}/> */}
      <span className='welcome__text'>Buenos dias, {shortenedUserName()}!</span>
      {schoolsList && (
        <span className='welcome__schools'>
          Éstas son tus escuelas asignadas
        </span>
      )}
    </div>
  );
}

export default WelcomeUser;
